import http from "./http_common";

class UserService {
  queryString(payload) {
    const QueryString = Object.keys(payload)
      .map((key) => key && payload[key] && key + "=" + payload[key])
      .join("&");
    return QueryString;
  }

  addDoctor(payload) {
    return http.post("/enrollmentFormDetails/save", payload);
  }

  addPatient(payload) {
    return http.post("/patient/consultation/save", payload);
  }

  getDoctors(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/user/consultation/list/filter?${queryString}`);
  }

  getReferal(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/Referral/list/filter?${queryString}`);
  }

  getDoctorSpeciality(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/Speciality/list?${queryString}`);
  }

  getInTouch(payload) {
    return http.post("/SubscriptionPlanType/save-getintouch", payload);
  }

   getUser(payload) {
      const queryString = this.queryString(payload);
      return http.get(`/user/list/filter?${queryString}`);
   }
}

export default new UserService();
